import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { Container, Row, Col } from 'react-bootstrap';
import { Header } from 'components/header';
import { useForm, FormProvider } from 'react-hook-form';
import initialState from 'utils/initial-state';
import { ProgressBarWellbeing } from 'components/progress-bar-wellbeing';
import { ProgressBarWorklife } from 'components/progress-bar-worklife';
import { ProgressBarWealth } from 'components/progress-bar-wealth';
import { useLazyQuery } from '@apollo/client/react';
import { calculateResult } from 'graphql/queries';
import type { FormData } from 'graphql/__generated__/graphql';
import AutomaticLogout from 'components/automatic-logout/automatic-logout';

export const LayoutWithProvider = () => {
    const [formData, setFormData] = useState<FormData>();
    const [finishedQuestionaire, setFinishedQuestionaire] = useState(false);

    const navigate = useNavigate();

    const [submitForm, { data, loading, error }] = useLazyQuery(calculateResult);

    const onSubmit = (data: any) => {
        setFormData(data);
        setFinishedQuestionaire(true);
    };

    const hookForm = useForm({
        defaultValues: initialState,
    });

    useEffect(() => {
        if (finishedQuestionaire) {
            submitForm({ variables: { input: formData! } });

            if (error || loading || data) {
                if (error) {
                    console.error(error);
                }
                if (data || loading) {
                    const answers = data!.calculateResult.answers;
                    const score = data!.calculateResult.score;
                    const overallSectionParagraphs = data!.calculateResult.overallSectionParagraphs;
                    const topTips = data!.calculateResult.topTips;
                    const allSectionTips = data!.calculateResult.allSectionTips;
                    const totalPercentage = data!.calculateResult.totalPercentage;

                    navigate('/results', {
                        state: { answers, score, overallSectionParagraphs, topTips, allSectionTips, totalPercentage },
                    });
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData, finishedQuestionaire, data]);

    return (
        <>
            <AutomaticLogout />
            <Header />

            <FormProvider {...hookForm}>
                <Container style={{ maxWidth: 1020, marginTop: 60 }}>
                    <Row className="g-0">
                        <Col className="px-0">
                            <ProgressBarWellbeing />
                        </Col>
                        <Col className="px-0">
                            <ProgressBarWorklife />
                        </Col>
                        <Col className="px-0">
                            <ProgressBarWealth />
                        </Col>
                    </Row>
                </Container>
                <form onSubmit={hookForm.handleSubmit(onSubmit)}>
                    <Outlet />
                </form>
            </FormProvider>
        </>
    );
};
